import { Typography } from '@mui/material';
import { DateTime } from '@utils/datetime';

export default function AssessmentReportLastUsed({ lastUsedAt }: { lastUsedAt: Date }) {
  const dt = DateTime.fromDate(lastUsedAt);

  if (!dt || dt.unix === 0) {
    return (
      <Typography color="text.muted" variant="inherit">
        Unused
      </Typography>
    );
  }

  return <>{dt.readableRelative}</>;
}
